// extracted by mini-css-extract-plugin
module.exports = {"seperator":"seperator_seperator__DLKbA","horizontal":"seperator_horizontal__15lSh","vertical":"seperator_vertical__AH6Pj"};